"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rUpper = /([A-Z])/g;
function hyphenate(s) {
    return s.replace(rUpper, '-$1').toLowerCase();
}
exports.hyphenate = hyphenate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/util/hyphenate.js
// module id = 190
// module chunks = 0 1 2 3 4 5 6